import { Box, Collapse, Group, ThemeIcon, UnstyledButton } from '@mantine/core';
import { IconChevronRight } from '@tabler/icons-react';
import { useState } from 'react';
import { useTranslation } from 'react-i18next';

import { LinkItem } from '@/types/nav-item';

import NavItem from '../item';

export default ({ icon: Icon, label, links }: LinkItem) => {
  const { t } = useTranslation();
  const [opened, setOpened] = useState(false);

  const ChevronIcon = IconChevronRight;

  return (
    <>
      <UnstyledButton
        onClick={() => {
          setOpened((o) => !o);
        }}
        component="div"
        className="select-none"
      >
        <Group justify="space-between" gap={0} className="py-2 px-4 hover:bg-gray-200">
          <Box style={{ display: 'flex', alignItems: 'center' }}>
            {Icon && (
              <ThemeIcon variant="light" size={30}>
                <Icon size="1.1rem" />
              </ThemeIcon>
            )}
            <Box ml="md">{t(label)}</Box>
          </Box>
          <ChevronIcon
            size="1rem"
            stroke={1.5}
            style={{
              transform: opened ? `rotate(${90}deg)` : 'none',
            }}
          />
        </Group>
      </UnstyledButton>
      <Collapse in={opened} pl={28}>
        {links?.map((link, index) => {
          return <NavItem key={index} {...link} />;
        })}
      </Collapse>
    </>
  );
};
